import React, { useEffect, useState } from "react";
import axios from "@/lib/axios";
import { API_BASE_URL } from "@/config";
import FullScreenLoader from "@/components/FullScreenLoader";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useJourney } from "@/contexts/JourneyContext";
import JourneyHeader from "@/components/JourneyHeader";

const RequirementsAppJourney = () => {
  const navigate = useNavigate();
  const { refresh: refreshJourney, logEvent } = useJourney();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const [content, setContent] = useState<string | null>(null);

  useEffect(() => {
    const fetchRequirements = async () => {
      try {
        const res = await axios.post(
          `${API_BASE_URL}/api/get_requirements_of_app_journey/`,
          {}
        );

        setContent(res.data.content || null);
        setLoading(false);
      } catch (err) {
        setError("Failed to load content");
        setLoading(false);
      }
    };

    fetchRequirements();
  }, []);

  if (loading) return <FullScreenLoader loading={true} />;
  if (error) return <p className="text-red-600 text-center mt-4">{error}</p>;

  return (
    <div className="min-h-screen bg-intellend-white">
      {/* Compact header */}
      <JourneyHeader />

      {/* Main content */}
      <main className="container mx-auto px-3 py-4 max-w-2xl">

        <div className="min-h-screen bg-white p-4">
          <h1 className="text-xl font-semibold mb-4">
            Requirements Information
          </h1>

          <div
            className="border p-4 rounded-md bg-gray-50"
            dangerouslySetInnerHTML={{ __html: content || "" }}
          />
          <div className="mt-6 flex justify-end">
            <Button
              onClick={async () => {
                try {
                  // Advance stage dynamically (backend calculates next stage)
                  const res = await logEvent({
                    stage: "", // Empty stage triggers auto-advance in backend
                    event_type: "stage_advance",
                    advance: true,
                  });

                  // Refresh journey state to get the updated stage
                  await refreshJourney();

                  // Use returned next_page_url or fallback
                  if (res && res.next_page_url) {
                    navigate(res.next_page_url);
                  } else {
                    // Fallback if no URL returned (shouldn't happen with new backend)
                    navigate("/personal-info");
                  }
                } catch (err) {
                  console.error("Failed to advance journey stage:", err);
                  // If advance fails, try navigating anyway (though backend might block)
                  navigate("/personal-info");
                }
              }}
              className="w-full sm:w-auto sm:ml-auto bg-intellend-green hover:bg-intellend-green/90 h-9"
            >
              Next
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default RequirementsAppJourney;
